var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c("Subheader", {
                attrs: { title: "Station Graph Visiblity", "no-search": "" },
              }),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: true } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  !_vm.isLoading
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md10: "", "offset-md1": "" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "align-center": "",
                                  },
                                },
                                [
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _vm._v("Toggle Graph Tab Visibility"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-checkbox", {
                                        on: {
                                          change:
                                            _vm.handleToggleGraphVisibility,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _vm.graphVisibilityToggleIsLoading
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                indeterminate:
                                                                  _vm.graphVisibilityToggleIsLoading,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3997503977
                                        ),
                                        model: {
                                          value: _vm.graphTabIsVisibleForm,
                                          callback: function ($$v) {
                                            _vm.graphTabIsVisibleForm = $$v
                                          },
                                          expression: "graphTabIsVisibleForm",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }